import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportBusinessSocialMedia } from 'dashboard/models/report/business-social-media';

interface BusinessSocialMediaProps {
  report: ReportBusinessSocialMedia;
  isRedacted: boolean;
}

export const BusinessSocialMedia = ({ report, isRedacted }: BusinessSocialMediaProps) => {
  const { name: name, ticker: ticker, profile: profile, website: website } = report.attributes;

  return (
    <AttributeGrid>
      {name && (
        <AttributeItem
          title='Name'
          value={name}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-social-media__name'
        />
      )}
      {ticker && (
        <AttributeItem
          title='Ticker'
          value={ticker}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-social-media__ticker'
        />
      )}
      {profile && (
        <AttributeItem
          title='profile'
          value={profile}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-social-media__profile'
        />
      )}
      {website && (
        <AttributeItem
          title='Website'
          value={website}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-social-media__website'
        />
      )}
    </AttributeGrid>
  );
};
